import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import ScopeCount from '@zen/Components/ScopeCount';
import { Gateway } from '@zen/DesignSystem';
import type { Undefinable } from '@zen/utils/typescript';

import { scopeConfigs } from './helpers';
import type { BookingScopesProps, ScopeConfig } from './types';

const BookingScopes: FC<BookingScopesProps> = (props) => {
  const { activeScope, isLoading, kpiCounts, onScopeChange } = props;

  const renderScopeTile = (scopeConfig: ScopeConfig): ReactNode => {
    const { image, kpiField, label, scope } = scopeConfig;

    const isActive: boolean = scope === activeScope;
    const count: Undefinable<number> = kpiCounts?.[kpiField];
    const gatewayClassNames: string = cx('relative flex h-31 flex-1 min-w-0 items-end overflow-clip p-4', {
      '!border-azure-base': isActive
    });

    const handleClick = (): void => {
      onScopeChange(scope);
    };

    return (
      <Gateway key={scope} className={gatewayClassNames} onClick={handleClick}>
        <div className="flex flex-1 flex-col gap-1">
          <ScopeCount count={count} isLoading={isLoading} />
          <div className="text-sm font-bold leading-5 text-grey-dark">{label}</div>
        </div>
        <img alt={label} className="pointer-events-none absolute top-4 right-1.5 size-16" src={image} />
      </Gateway>
    );
  };

  return (
    <div className="flex gap-4" data-component="booking-scopes">
      {scopeConfigs.map(renderScopeTile)}
    </div>
  );
};

export type { BookingScopesProps } from './types';
export default BookingScopes;
